import { Component } from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import { History } from "history";
import {
    DefaultButton,
    Dialog,
    DialogFooter,
    DialogType,
    Dropdown,
    PrimaryButton,
    TextField,
} from "office-ui-fabric-react";
import AbsoluteLoader from '../Loader/AbsoluteLoader';
import { RootState } from "app/redux/reducer";
import { setModalData, toggleModal } from "app/redux/modal/actions";
import { createSpecificationType, getSpecificationTypes, updateSpecificationType } from "app/services/specification";
import { castThunkAction } from "app/utils/casting";
import { specificationKeys } from "app/shared/constants/spec";

interface OwnProps {
    history: History<any>;
}

function mapStateToProps(state: RootState) {
    return {
        ...state.modal.specificationType,
        language: state.system.language,
        modalLoading: state.system.modalLoading
    };
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        ...bindActionCreators(
            {
                setModalData,
                toggleModal,
                createSpecificationType,
                getSpecificationTypes,
                updateSpecificationType
            },
            dispatch
        ),
    };
}

type SpecificationTypeModalProps = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps> &
    OwnProps;

class SpecificationTypeModal extends Component<SpecificationTypeModalProps> {

    onClose() {
        if (this.props.callback) {
            this.props.callback()
        }
        this.props.toggleModal("specificationType", {});
    }

    onSave() {
        castThunkAction(this.props.data.id ? this.props.updateSpecificationType(this.props.data) : this.props.createSpecificationType(this.props.data)).then(res => {
            if (res) {
                this.props.getSpecificationTypes({ page: 1, pageSize: 1000, descending: false });
                this.onClose();
            }
        })
    }

    onChangeData(key: string, value: any) {
        this.props.setModalData("specificationType", {
            ...this.props.data,
            [key]: value
        })
    }

    renderForm() {
        return (
            <div className="modal-form">
                <div className="row reverse-margin">
                    <div className="item col-md-6">
                        <TextField
                            placeholder="Tip Adı"
                            value={this.props.data.title || ""}
                            label="Tip Adı"
                            className="custom-textfield border"
                            onChange={(event: any) => this.onChangeData("title", event.target.value)}
                        />
                    </div>
                    <div className="item col-md-6">
                        <Dropdown
                            placeholder="Tip Key"
                            selectedKey={this.props.data.key || ""}
                            label="Tip Key"
                            className="custom-dropdown border"
                            calloutProps={{ className: "custom-dropdown-callout" }}
                            onChange={(event: any, option) => this.onChangeData("key", option?.key as string)}
                            options={specificationKeys.map(item => ({ key: item.key, text: item.key }))}
                        />
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { data, show, modalLoading } = this.props;

        if (!show) return null;

        return (
            <Dialog
                hidden={!show}
                onDismiss={() => this.onClose()}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: data.id ? "Spesifikasyon Kategorisini Düzenle" : "Yeni Spesifikasyon Kategorisi Ekle",
                    closeButtonAriaLabel: "Kapat",
                    subText:
                        "Aşağıdaki bilgileri doldurarak belirlediğiniz kriterlerde bir spesifikasyon kategorisi ekleyin ya da düzenleyin."
                }}
                modalProps={{
                    className: "confirm",
                    isBlocking: true,
                    styles: { main: { maxWidth: "1000px !important" } },
                }}
            >
                <AbsoluteLoader show={modalLoading} />
                {this.renderForm()}
                <DialogFooter>
                    <DefaultButton
                        onClick={() => this.onClose()}
                        text="İptal"
                    />
                    <PrimaryButton
                        onClick={() => this.onSave()}
                        text={data.id ? "Güncelle" : "Ekle"}
                        disabled={(!data.title || modalLoading) ? true : false}
                    />
                </DialogFooter>
            </Dialog>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecificationTypeModal);
